import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import ContactSupportForm from "@/components/ContactSupportForm";
import { Card } from "@/components/ui/card";
import { safeStorage } from "@/lib/storage";

export default function ContactSupport() {
    const navigate = useNavigate();
    const [completedSteps, setCompletedSteps] = useState<number[]>([]);

    useEffect(() => {
        const steps = safeStorage.get("completedTroubleshootingSteps") ?? [];
        setCompletedSteps(steps);
    }, []);

    return (
        <section className="max-w-5xl mx-auto space-y-6">
            <Card className="p-6 border-primary/20 shadow-lg">
                <ContactSupportForm
                    onBack={() => navigate("/troubleshooting")}
                    completedSteps={completedSteps}
                />
            </Card>
        </section>
    );
}
